import {type FC} from 'react';

import {CompleteTaskPopupTemplate} from '@/views/Loyalty/PopupTemplates';

interface ICompleteTaskTemplateProps {
    loyaltyInfo?: {
        journeyId: string;
        actionIndex: number;
        levelIndex: number;
    };
    subTitle?: string;
}

export const CompleteTaskTemplate: FC<ICompleteTaskTemplateProps> = ({loyaltyInfo, subTitle}) => {
    return (
        <div className='mb-6 bg-primary-dark px-6 py-6 ml:p-0'>
            <h2 className='mb-4 mt-8 text-20 font-bold text-primary-dark-30 ml:m-0'>{subTitle}</h2>
            <CompleteTaskPopupTemplate buttonClassName='-mt-4' actionInfo={loyaltyInfo} />
        </div>
    );
};
